module.exports = __webpack_public_path__ + "static/media/user.1cf50515.proto";